/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  addEventToCalendar({ commit }, event) {
    commit('ADD_EVENT_TO_CALENDAR', event);
  },
  ediCalendarEvent({ commit }, event) {
    commit('EDIT_CALENDAR_EVENT', event);
  },
  removeCalendarEvent({ commit }, eventId) {
    commit('REMOVE_CALENDAR_EVENT', eventId);
  },

  // Simple Calendar Actions
  addEventToSimpleCalendar({ commit }, event) {
    commit('ADD_EVENT_TO_SIMPLE_CALENDAR', event);
  },
  editSimpleCalendarEvent({ commit }, event) {
    commit('EDIT_SIMPLE_CALENDAR_EVENT', event);
  },
  removeSimpleCalendarEvent({ commit }, eventId) {
    commit('REMOVE_SIMPLE_CALENDAR_EVENT', eventId);
  },
  async simpleCalendarEventDragged({ commit }, payload) {
    // Check if this is a review assignment that needs backend persistence
    if (payload.event.isReview || payload.event.isCompleteSOP) {
      try {
        // Extract assignment ID from the event
        const assignmentId = payload.event.reviewId || payload.event.id?.replace('review-', '').replace('complete-sop-', '');
        
        if (assignmentId) {
          // Call backend API to update the assignment due date
          const mutation = `
            mutation UpdateAssignmentDueDate($assignmentId: Int!, $newDueDate: DateTime!) {
              updateAssignmentDueDate(assignmentId: $assignmentId, newDueDate: $newDueDate)
            }
          `;

          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: mutation,
            variables: {
              assignmentId: parseInt(assignmentId),
              newDueDate: payload.date.toISOString()
            }
          });

          if (response && response.data && response.data.data && response.data.data.updateAssignmentDueDate) {
            console.log('Assignment due date updated successfully');
          } else {
            console.error('Failed to update assignment due date:', response);
          }
        }
      } catch (error) {
        console.error('Error updating assignment due date:', error);
      }
    }
    
    // Update local state
    commit('SIMPLE_CALENDAR_EVENT_DRAGGED', payload);
  },

  // Review Assignments Actions
  loadReviewAssignments({ commit }, assignments) {
    commit('LOAD_REVIEW_ASSIGNMENTS', assignments);
  }
}
